module.exports = __webpack_public_path__ + "static/media/FMB_icon2.964002b9.svg";